import { createValidationSchema, permissionsValues, validate } from "@";
import * as yup from "yup";

export const editSchema = createValidationSchema({
  email: validate("email", "email"),
  displayName: validate("req", "displayName"),

  // password is optional, but if it's provided it must be valid
  password: yup.string(),
});

export const createSchema = createValidationSchema({
  name: validate("req", "name"),
  type: validate("number", "type"),
  email: validate("email", "email"),
  password: validate("password", "password"),
  phoneNumber: validate("nullablePhone", "phoneNumber"),
});

export const createDefaultValues = {
  type: 6,
  name: "",
  email: "",
  password: "",
  phoneNumber: "",
  permissions: permissionsValues,
};

export const editDefaultValues = {
  id: null,
  name: "",
  email: "",
  password: "",
  phoneNumber: "",
};
